import { StaticImage } from "gatsby-plugin-image"
import React from "react"

export default [
	{
		title: "Простая установка",
		description: (
			<>
				Подключается к&nbsp;планшетам
				<br />
				на&nbsp;базе Android и&nbsp;телевизорам
				на&nbsp;базе&nbsp;Android&nbsp;TV.
			</>
		),
	},
	{
		title: "Всё в одном месте",
		description:
			"Подружим заказы из зала, приложения и с сайта: неважно, где гость оформил заказ.",
	},
	{
		title: "С пылу с жару",
		description:
			"Заказ попадает к гостю вовремя, свежим и горячим — гость доволен.",
	},
]
